import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { practiceCards } from '../../data/practiceCards';
export function PracticeCards() {
  return <section className="bg-white py-14 sm:py-16" data-id="element-164" data-mp="szqgjwdzczic">
      <div className="mx-auto max-w-3xl px-6 text-center sm:px-8" data-id="element-165" data-mp="t11gtm87vp4p">
        <SectionTag icon="👀" data-id="element-166" data-mp="x0a9enritgyo">Esto es lo que recibes</SectionTag>
        <h2 className="mt-5 font-heading text-[28px] font-bold uppercase text-marino sm:text-[36px]" data-id="element-167" data-mp="1kqmruske6w3i">
          Fichas prácticas diseñadas para consultar en 30 segundos
        </h2>
      </div>

      <div className="mx-auto mt-10 grid max-w-6xl gap-5 px-6 sm:grid-cols-3 sm:px-8" data-id="element-168" data-mp="1pnd5l98q5flr">
        {practiceCards.map((card, i) => <m.div key={card.title} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="rounded-2xl border border-gris-claro bg-white p-5 shadow-leve" data-id="element-169" data-mp="1go9p8d0xzeay" data-mpi={i}>
            <img src={card.image} alt={card.title} loading="lazy" decoding="async" className="w-full rounded-xl border border-gris-claro" data-id="element-170" data-mp="1bi1iqino79q3" />
            <h3 className="mt-4 font-heading text-base font-semibold text-marino" data-id="element-171" data-mp="1ldmj6cd3c1xq">{card.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-gris-texto" data-id="element-172" data-mp="1gip7exoffeh5">{card.text}</p>
          </m.div>)}
      </div>
    </section>;
}